var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFullLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 80,
    viewBox: "0 0 286 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.08 63C70.6107 63 70.2267 62.8507 69.928 62.552C69.6293 62.2533 69.48 61.8693 69.48 61.4V19.8C69.48 19.3307 69.6293 18.9467 69.928 18.648C70.2267 18.3493 70.6107 18.2 71.08 18.2H100.968C101.437 18.2 101.821 18.3493 102.12 18.648C102.419 18.9467 102.568 19.3307 102.568 19.8V25.816C102.568 26.2853 102.419 26.6693 102.12 26.968C101.821 27.2667 101.437 27.416 100.968 27.416H80.552V36.056H99.56C100.029 36.056 100.413 36.2267 100.712 36.568C101.011 36.8667 101.16 37.2507 101.16 37.72V43.288C101.16 43.7147 101.011 44.0987 100.712 44.44C100.413 44.7387 100.029 44.888 99.56 44.888H80.552V53.784H101.48C101.949 53.784 102.333 53.9333 102.632 54.232C102.931 54.5307 103.08 54.9147 103.08 55.384V61.4C103.08 61.8693 102.931 62.2533 102.632 62.552C102.333 62.8507 101.949 63 101.48 63H71.08ZM127.059 63.64C122.792 63.64 119.251 63.0427 116.435 61.848C113.619 60.6107 111.486 59.0107 110.035 57.048C108.584 55.0853 107.816 52.9947 107.731 50.776C107.731 50.4347 107.859 50.136 108.115 49.88C108.414 49.5813 108.755 49.432 109.139 49.432H117.203C117.8 49.432 118.248 49.5387 118.547 49.752C118.888 49.9653 119.187 50.2427 119.443 50.584C119.784 51.224 120.254 51.8427 120.851 52.44C121.491 53.0373 122.302 53.528 123.283 53.912C124.307 54.2533 125.566 54.424 127.059 54.424C129.534 54.424 131.39 54.04 132.627 53.272C133.907 52.504 134.547 51.4587 134.547 50.136C134.547 49.1973 134.206 48.4293 133.523 47.832C132.84 47.192 131.731 46.6373 130.195 46.168C128.702 45.656 126.696 45.144 124.179 44.632C120.936 43.9493 118.163 43.0747 115.859 42.008C113.598 40.8987 111.87 39.4693 110.675 37.72C109.48 35.928 108.883 33.7093 108.883 31.064C108.883 28.4613 109.608 26.136 111.059 24.088C112.552 22.04 114.622 20.44 117.267 19.288C119.912 18.136 123.048 17.56 126.675 17.56C129.619 17.56 132.2 17.944 134.419 18.712C136.68 19.48 138.579 20.504 140.115 21.784C141.651 23.064 142.803 24.4293 143.571 25.88C144.382 27.288 144.808 28.6747 144.851 30.04C144.851 30.3813 144.723 30.7013 144.467 31C144.211 31.256 143.891 31.384 143.507 31.384H135.059C134.59 31.384 134.184 31.2987 133.843 31.128C133.502 30.9573 133.203 30.68 132.947 30.296C132.691 29.3573 132.008 28.5467 130.899 27.864C129.832 27.1387 128.424 26.776 126.675 26.776C124.798 26.776 123.326 27.1173 122.259 27.8C121.235 28.44 120.723 29.4427 120.723 30.808C120.723 31.6613 121 32.408 121.555 33.048C122.152 33.688 123.112 34.2427 124.435 34.712C125.8 35.1813 127.656 35.672 130.003 36.184C133.886 36.9093 137.022 37.8267 139.411 38.936C141.8 40.0027 143.55 41.4107 144.659 43.16C145.768 44.8667 146.323 47.0213 146.323 49.624C146.323 52.5253 145.491 55.0427 143.827 57.176C142.206 59.2667 139.944 60.8667 137.043 61.976C134.142 63.0853 130.814 63.64 127.059 63.64Z",
    fill: "url(#paint0_linear_1_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 40.554C61 57.8074 46.5822 66.5613 28.797 66.5613C11.0117 66.5613 12.1301 57.8074 12.1301 40.554C12.1301 23.3006 11.0117 14 28.797 14C46.5822 14 61 23.3006 61 40.554Z",
    fill: "url(#paint1_linear_1_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6526 52.9602C25.094 52.9602 27.0732 52.9022 27.0732 55.2194C27.0732 57.5365 25.094 59.4149 22.6526 59.4149C20.2112 59.4149 18.2321 57.5365 18.2321 55.2194C18.2321 52.9022 20.2112 52.9602 22.6526 52.9602Z",
    fill: "url(#paint2_linear_1_4)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 29.6763,
    width: 33.3516,
    height: 17.751,
    rx: 8.87548,
    fill: "url(#paint3_linear_1_4)",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 29.6763,
    width: 33.3516,
    height: 17.751,
    rx: 8.87548,
    fill: "url(#paint4_linear_1_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5136 38.667C15.5136 41.5954 15.5747 43.9693 13.1352 43.9693C10.6958 43.9693 8.7182 41.5954 8.7182 38.667C8.7182 35.7387 10.6958 33.3648 13.1352 33.3648C15.5747 33.3648 15.5136 35.7387 15.5136 38.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.936 63C164.467 63 164.083 62.8507 163.784 62.552C163.485 62.2533 163.336 61.8693 163.336 61.4V28.248H151.944C151.475 28.248 151.091 28.0987 150.792 27.8C150.493 27.4587 150.344 27.0747 150.344 26.648V19.8C150.344 19.3307 150.493 18.9467 150.792 18.648C151.091 18.3493 151.475 18.2 151.944 18.2H186.376C186.845 18.2 187.229 18.3493 187.528 18.648C187.827 18.9467 187.976 19.3307 187.976 19.8V26.648C187.976 27.0747 187.827 27.4587 187.528 27.8C187.229 28.0987 186.845 28.248 186.376 28.248H174.984V61.4C174.984 61.8693 174.835 62.2533 174.536 62.552C174.237 62.8507 173.853 63 173.384 63H164.936ZM195.393 63C194.923 63 194.539 62.8507 194.241 62.552C193.942 62.2533 193.793 61.8693 193.793 61.4V19.8C193.793 19.3307 193.942 18.9467 194.241 18.648C194.539 18.3493 194.923 18.2 195.393 18.2H225.281C225.75 18.2 226.134 18.3493 226.433 18.648C226.731 18.9467 226.881 19.3307 226.881 19.8V25.816C226.881 26.2853 226.731 26.6693 226.433 26.968C226.134 27.2667 225.75 27.416 225.281 27.416H204.865V36.056H223.873C224.342 36.056 224.726 36.2267 225.025 36.568C225.323 36.8667 225.472 37.2507 225.472 37.72V43.288C225.472 43.7147 225.323 44.0987 225.025 44.44C224.726 44.7387 224.342 44.888 223.873 44.888H204.865V53.784H225.793C226.262 53.784 226.646 53.9333 226.944 54.232C227.243 54.5307 227.393 54.9147 227.393 55.384V61.4C227.393 61.8693 227.243 62.2533 226.944 62.552C226.646 62.8507 226.262 63 225.793 63H195.393ZM236.268 63C235.798 63 235.414 62.8507 235.116 62.552C234.817 62.2533 234.668 61.8693 234.668 61.4V19.8C234.668 19.3307 234.817 18.9467 235.116 18.648C235.414 18.3493 235.798 18.2 236.268 18.2H253.676C259.18 18.2 263.51 19.48 266.668 22.04C269.868 24.5573 271.468 28.1413 271.468 32.792C271.468 35.8213 270.721 38.3813 269.228 40.472C267.777 42.5627 265.857 44.1413 263.468 45.208L272.3 60.952C272.428 61.208 272.492 61.4427 272.492 61.656C272.492 61.9973 272.342 62.3173 272.044 62.616C271.788 62.872 271.468 63 271.084 63H262.636C261.825 63 261.228 62.808 260.844 62.424C260.46 61.9973 260.182 61.6133 260.012 61.272L252.716 47.192H246.124V61.4C246.124 61.8693 245.974 62.2533 245.676 62.552C245.377 62.8507 244.993 63 244.524 63H236.268ZM246.124 38.168H253.548C255.553 38.168 257.046 37.6773 258.028 36.696C259.052 35.7147 259.564 34.3707 259.564 32.664C259.564 31 259.073 29.656 258.092 28.632C257.153 27.608 255.638 27.096 253.548 27.096H246.124V38.168Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_4",
    x: -14,
    y: 14.6763,
    width: 73.3516,
    height: 57.751,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4",
    x1: 69.096,
    y1: 10.4399,
    x2: 177.878,
    y2: 88.7389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_4",
    x1: 52.9035,
    y1: 1.20548,
    x2: 12.5637,
    y2: 48.1118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFE0",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_4",
    x1: 18.2055,
    y1: 53.9921,
    x2: 29.6922,
    y2: 59.5555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BFFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_4",
    x1: 7.15448,
    y1: 29.6763,
    x2: 40.0829,
    y2: 42.6604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_4",
    x1: 7.15448,
    y1: 29.6763,
    x2: 40.0829,
    y2: 42.6604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 286,
    height: 80,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFullLight);
export default __webpack_public_path__ + "static/media/logo-full-light.f4ab9252b3a9572726247d40da5304aa.svg";
export { ForwardRef as ReactComponent };